export interface BlogPost {
  slug: string;
  title: string;
  metaTitle: string;
  metaDescription: string;
  category: string;
  emoji: string;
  excerpt: string;
  readTime: string;
  date: string;
  author: string;
}

export const blogPosts: BlogPost[] = [
  {
    slug: "5-tecnicas-para-nunca-mais-procrastinar",
    title: "5 Técnicas para Nunca Mais Procrastinar",
    metaTitle: "5 Técnicas Infalíveis para Parar de Procrastinar | HabitFrog",
    metaDescription: "Descubra como parar de procrastinar com 5 técnicas cientificamente comprovadas. Aprenda a usar Pomodoro, dividir tarefas, criar metas e aumentar sua produtividade.",
    category: "Produtividade",
    emoji: "🎯",
    excerpt: "Descubra métodos comprovados para vencer a procrastinação de uma vez por todas.",
    readTime: "15 min de leitura",
    date: "28 Dez 2025",
    author: "Equipe HabitFrog"
  },
  {
    slug: "ciencia-formacao-habitos",
    title: "A Ciência Por Trás da Formação de Hábitos",
    metaTitle: "A Ciência da Formação de Hábitos: Neurociência e Comportamento | HabitFrog",
    metaDescription: "Entenda como o cérebro forma hábitos, o papel dos gânglios basais, dopamina e neuroplasticidade. Descubra por que leva 66 dias para criar um novo hábito.",
    category: "Ciência",
    emoji: "🧠",
    excerpt: "Entenda como seu cérebro forma hábitos e use isso a seu favor.",
    readTime: "20 min de leitura",
    date: "25 Dez 2025",
    author: "Equipe HabitFrog"
  },
  {
    slug: "como-a-meditacao-diaria-mudou-minha-vida",
    title: "Como a Meditação Diária Mudou Minha Vida",
    metaTitle: "Como a Meditação Diária Mudou Minha Vida: Depoimento de Empresário | HabitFrog",
    metaDescription: "Depoimento real de um empresário que fatura R$ 5 milhões/mês sobre como a meditação transformou sua liderança, relacionamentos e resultados nos negócios.",
    category: "Bem-estar",
    emoji: "🧘",
    excerpt: "Um relato pessoal sobre os benefícios de meditar apenas 10 minutos por dia.",
    readTime: "25 min de leitura",
    date: "20 Dez 2025",
    author: "Ricardo Mendes"
  },
  {
    slug: "como-criar-o-habito-de-exercicios",
    title: "Como Criar o Hábito de Exercícios",
    metaTitle: "Como Criar o Hábito de Exercícios Físicos: Guia Completo | HabitFrog",
    metaDescription: "Aprenda como criar o hábito de exercícios físicos de forma definitiva. Dicas de atletas, história real de superação e estratégias comprovadas para nunca mais abandonar o treino.",
    category: "Fitness",
    emoji: "💪",
    excerpt: "Guia completo com histórias reais e estratégias de atletas de elite para criar e manter uma rotina de exercícios.",
    readTime: "20 min de leitura",
    date: "15 Dez 2025",
    author: "Equipe HabitFrog"
  },
  {
    slug: "leia-52-livros-por-ano",
    title: "Leia 52 Livros Por Ano",
    metaTitle: "Como Ler 52 Livros Por Ano: Guia Prático | HabitFrog",
    metaDescription: "Aprenda técnicas para ler um livro por semana. Descubra como criar o hábito de leitura e transformar sua vida.",
    category: "Aprendizado",
    emoji: "📚",
    excerpt: "Técnicas para ler um livro por semana e transformar sua vida.",
    readTime: "10 min de leitura",
    date: "10 Dez 2025",
    author: "Equipe HabitFrog"
  },
  {
    slug: "rotina-noturna-para-dormir-melhor",
    title: "Rotina Noturna Para Dormir Melhor",
    metaTitle: "Rotina Noturna Para Dormir Melhor: 7 Hábitos | HabitFrog",
    metaDescription: "Crie uma rotina noturna perfeita para melhorar a qualidade do seu sono. Dicas práticas para dormir mais rápido e acordar renovado.",
    category: "Sono",
    emoji: "💤",
    excerpt: "Crie uma rotina noturna que vai revolucionar sua qualidade de sono.",
    readTime: "8 min de leitura",
    date: "5 Dez 2025",
    author: "Equipe HabitFrog"
  }
];

export const getPostBySlug = (slug: string): BlogPost | undefined => {
  return blogPosts.find(post => post.slug === slug);
};
